import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PopupModule} from '../shared/popup/popup.module';
import { CustomerDetailComponent } from './customer-detail.component';
import { DepositInfoComponent } from './deposit-info/deposit-info.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { LineInfoComponent } from './line-info/line-info.component'

//import { SharedService } from '../shared/shared.service';
//import { CustomerService } from '../services/customer.service';
//import { LookupService } from '../services/lookup.service';
//import { CartService } from '../services/cart.service';

@NgModule({
    imports: [ RouterModule, CommonModule, PopupModule ],
    declarations: [
        CustomerDetailComponent,
        DepositInfoComponent,
        AccountInfoComponent,
        OrderHistoryComponent,
        LineInfoComponent
    ],
    exports: [ CustomerDetailComponent ],
    providers: [ ],
})

export class CustomerDetailModule {}
